var EVENTS = {

	update: 'update',

	resize: 'resize',

	occlusion: 'occlusion',

	switch_post_pro: 'switch_post_pro',

	postupdate: 'postupdate',

	drop: 'ondrop'

}

export default EVENTS;



// WEBPACK FOOTER //
// ./src/scripts/Trail/globals/eventslist.js